import { ModelsLayout } from '@/components/layout/models'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/models/')({
  component: ModelsPage,
  head: () => ({
    meta: [
      { name: 'SUL AI', content: 'SUL AI' },
      { title: 'SUL AI | Available Models' },
    ],
  }),
})

function ModelsPage() {
  return <ModelsLayout />
}
